var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApathetic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 3.4C5.45912 3.4 3.4001 5.46081 3.4001 8C3.4001 10.5392 5.45912 12.6 8.0001 12.6C10.5412 12.6 12.6001 10.5411 12.6001 8C12.6001 5.45891 10.5412 3.4 8.0001 3.4ZM2.6001 8C2.6001 5.01919 5.01708 2.6 8.0001 2.6C10.983 2.6 13.4001 5.01708 13.4001 8C13.4001 10.9829 10.983 13.4 8.0001 13.4C5.01708 13.4 2.6001 10.9808 2.6001 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02783 10.316C6.02783 10.0951 6.20692 9.916 6.42783 9.916H9.56983C9.79075 9.916 9.96983 10.0951 9.96983 10.316C9.96983 10.5369 9.79075 10.716 9.56983 10.716H6.42783C6.20692 10.716 6.02783 10.5369 6.02783 10.316Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53198 6.888C5.53198 6.44617 5.89015 6.088 6.33198 6.088H6.33798C6.77981 6.088 7.13798 6.44617 7.13798 6.888C7.13798 7.32983 6.77981 7.688 6.33798 7.688H6.33198C5.89015 7.688 5.53198 7.32983 5.53198 6.888ZM8.86598 6.888C8.86598 6.44617 9.22416 6.088 9.66598 6.088H9.67198C10.1138 6.088 10.472 6.44617 10.472 6.888C10.472 7.32983 10.1138 7.688 9.67198 7.688H9.66598C9.22416 7.688 8.86598 7.32983 8.86598 6.888Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApathetic);
export default __webpack_public_path__ + "static/media/apathetic.1ca5a6e48fbc10fdf90630a9e8f1a6c3.svg";
export { ForwardRef as ReactComponent };